import BlockType101Component from '@headlines/components/block/100-110/BlockType101.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType101: AdminBlockType = {
  component: BlockType101Component,
  attributes: AdminBlockTypeAttributes({
    icons: true,
    author: false,
    titleComment: true,
    channel: false,
    category: false,
    lead: false,
    publishDate: false,
    type: 'list',
  }),
  articlesCount: 30,
};

export default AdminBlockType101;
